import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
// views components
import Dashboard from "./views/Dashboard.vue";
import Analysis from "./views/Analysis.vue";
import Contacts from "./views/Contacts.vue";

import Documents from "./views/Documents.vue";
import DocumentTemplates from "./views/DocumentTemplates.vue";
import DocumentTemplate from "./views/DocumentTemplate.vue";
import TemplateLibraryNavigation from "./components/navigation/TemplateLibraryNavigation";
import TemplateLibrary from "./views/TemplateLibrary";

import Project from "./views/Project.vue";
import Projects from "./views/Projects.vue";
import Organization from "./views/Organization.vue";
import Organizations from "./views/Organizations.vue";
import System from "./views/System.vue";
import Login from "./views/Login";
import Logout from "./views/Logout";
import Profile from "./views/Profile";
import ConfirmEmail from "./views/ConfirmEmail.vue";
import Addressbook from "./views/Addressbook.vue";
import Contact from "./views/Contact.vue";
import Folder from "./views/Folder.vue";
import Document from "./views/Document.vue";
import Sources from "./views/projects/metering/Sources";
import Source from "./views/projects/metering/Source";
import SourceAdapterMessage from "./views/projects/metering/SourceAdapterMessage";
import SourceAdapters from "./views/projects/metering/SourceAdapters";
import SourceAdapter from "./views/projects/metering/SourceAdapter";
import Transmissions from "./views/projects/metering/Transmissions";
import Transmission from "./views/projects/metering/Transmission";
import Meters from "./views/projects/metering/Meters";

import AddressbookNavigation from "./components/navigation/AddressbookNavigation";
import FolderNavigation from "./components/navigation/FolderNavigation";

import Tariffs from "./views/projects/accounting/Tariffs";
import MeterUnits from "./views/projects/metering/MeterUnits";
import MeterUnit from "./views/projects/metering/MeterUnit";
import Incidents from "./views/projects/metering/Incidents";
import Groups from "./views/projects/metering/Groups";
import Tariff from "./views/projects/accounting/Tariff";
import Meter from "./views/projects/metering/Meter";
import Group from "./views/projects/metering/Group";
import ManageRecord from "./views/projects/metering/ManageRecord";
import AnalysisNavigation from "./components/navigation/AnalysisNavigation";
import UserGroupsNavigation from "./components/navigation/UserGroupsNavigation";
import Ingestions from "./views/projects/metering/Ingestions.vue";
import Ingestion from "./views/projects/metering/Ingestion.vue";
import Visualizations from "./views/projects/metering/Visualizations.vue";
import Visualization from "./views/projects/metering/Visualization.vue";

import CostCentres from "./views/projects/accounting/CostCentres";
import CostCentre from "./views/projects/accounting/CostCentre";
import ContractPeriods from "./views/projects/accounting/ContractPeriods";
import CostAllocator from "./views/projects/accounting/CostAllocator";
import BillingPeriod from "./views/projects/accounting/BillingPeriod";
import BillingPeriods from "./views/projects/accounting/BillingPeriods";
import CostItems from "./views/projects/accounting/CostItems";
import CostItem from "./views/projects/accounting/CostItem";
import ConsumptionAccounting from "./views/projects/accounting/ConsumptionAccounting";
import DataExportUpload from "./views/projects/accounting/DataExportUpload";
import DataExportValidation from "./views/projects/accounting/DataExportValidation";
import NotFound from "./views/NotFound";
import UserGroup from "./views/UserGroup.vue";
import UserGroups from "./views/Users.vue";
import TariffPlans from "@/views/projects/accounting/TariffPlans.vue";
import TariffPlan from "@/views/projects/accounting/TariffPlan.vue";

if (!process || process.env.NODE_ENV !== "test") {
  Vue.use(Router);
}
const router = new Router({
  mode: window.lexConfig.hasOwnProperty("router_mode_hash")
    ? "hash"
    : "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/confirm-email",
      name: "ConfirmEmail",
      component: ConfirmEmail
    },
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile
    },
    {
      path: "/analysis",
      name: "analyzes",
      components: {
        default: Analysis,
        PrimaryNavigation: AnalysisNavigation
      }
    },
    {
      path: "/analysis/:project/",
      name: "analysis",
      component: Analysis,
      components: {
        default: Analysis,
        PrimaryNavigation: AnalysisNavigation
      }
    },
    {
      path: "/contacts",
      name: "Contacts",
      components: {
        default: Contacts,
        PrimaryNavigation: AddressbookNavigation
      }
    },
    {
      path: "/user-groups",
      name: "UserGroups",
      components: {
        default: UserGroups,
        PrimaryNavigation: UserGroupsNavigation
      }
    },
    {
      path: "/user-groups/new",
      name: "NewUserGroup",
      component: UserGroup
    },
    {
      path: "/user-groups/:id",
      name: "UserGroup",
      component: UserGroup,
      props: true
    },
    {
      path: "/documents",
      name: "Documents",
      components: {
        default: Documents,
        PrimaryNavigation: FolderNavigation
      }
    },
    {
      path: "/document-templates",
      name: "DocumentTemplates",
      components: {
        default: DocumentTemplates,
        PrimaryNavigation: TemplateLibraryNavigation
      }
    },
    {
      path: "/document-templates/new",
      name: "NewDocumentTemplate",
      props: { default: true },
      components: {
        default: DocumentTemplate
      }
    },
    {
      path: "/document-templates/:id",
      name: "DocumentTemplate",
      props: { default: true },
      components: {
        default: DocumentTemplate
      }
    },

    {
      path: "/template-libraries/:id",
      name: "TemplateLibrary",
      component: TemplateLibrary,
      props: true
    },
    {
      path: "/projects",
      name: "projects",
      components: {
        default: Projects
      }
    },

    {
      path: "/projects/:id",
      name: "project",
      components: {
        default: Project
      }
    },
    {
      path: "/organizations/:organization_id/projects/:id",
      name: "organization-project",
      components: {
        default: Project
      }
    },
    {
      path: "/organizations/:organization_id/projects/new",
      name: "new-project",
      components: {
        default: Project
      }
    },

    {
      path: "/projects/:project_id/sources",
      name: "sources",
      component: Sources,
      props: true
    },
    {
      path: "/projects/:project_id/sources/:id",
      name: "source",
      component: Source,
      props: true
    },
    {
      path: "/projects/:project_id/source-adapters",
      name: "source-adapters",
      component: SourceAdapters,
      props: true
    },
    {
      path: "/projects/:project_id/source-adapters/new",
      name: "new-source-adapter",
      component: SourceAdapter,
      props: true
    },
    {
      path: "/projects/:project_id/source-adapters/:id",
      name: "source-adapter",
      component: SourceAdapter,
      props: true
    },
    {
      path: "/projects/:project_id/source-adapter-messages/:id",
      name: "source-adapter-message",
      component: SourceAdapterMessage,
      props: true
    },
    {
      path: "/projects/:project_id/transmissions",
      name: "transmissions",
      component: Transmissions,
      props: true
    },
    {
      path: "/projects/:project_id/transmissions/:id",
      name: "transmission",
      component: Transmission,
      props: true
    },
    {
      path: "/projects/:project_id/meters",
      name: "meters",
      component: Meters,
      props: true
    },
    {
      path: "/projects/:project_id/meters/new",
      name: "new-meter",
      component: Meter,
      props: true
    },
    {
      path: "/projects/:project_id/meters/:id",
      name: "meter",
      component: Meter,
      props: true
    },
    {
      path: "/projects/:project_id/tariffs",
      name: "tariffs",
      component: Tariffs,
      props: true
    },
    {
      path: "/projects/:project_id/tariffs/:id",
      name: "tariff",
      component: Tariff,
      props: true
    },
    {
      path: "/projects/:project_id/tariff-plans",
      name: "tariff-plans",
      component: TariffPlans,
      props: true
    },
    {
      path: "/projects/:project_id/tariff-plans/new",
      name: "new-tariff-plan",
      component: TariffPlan,
      props: true
    },
    {
      path: "/projects/:project_id/tariff-plans/:id",
      name: "tariff-plan",
      component: TariffPlan,
      props: true
    },
    {
      path: "/projects/:project_id/meter-units",
      name: "meter-units",
      component: MeterUnits,
      props: true
    },
    {
      path: "/projects/:project_id/meter-units/new",
      name: "new-meter-unit",
      component: MeterUnit,
      props: true
    },
    {
      path: "/projects/:project_id/meter-units/:id",
      name: "meter-unit",
      component: MeterUnit,
      props: true
    },
    {
      path: "/projects/:project_id/ingestions",
      name: "ingestions",
      component: Ingestions,
      props: true
    },
    {
      path: "/projects/:project_id/ingestions/new",
      name: "new-ingestion",
      component: Ingestion,
      props: true
    },
    {
      path: "/projects/:project_id/ingestions/:id",
      name: "ingestion",
      component: Ingestion,
      props: true
    },
    {
      path: "/projects/:project_id/visualizations",
      name: "visualizations",
      component: Visualizations,
      props: true
    },
    {
      path: "/projects/:project_id/visualizations/new",
      name: "new-visualization",
      component: Visualization,
      props: true
    },
    {
      path: "/projects/:project_id/visualizations/:id",
      name: "visualization",
      component: Visualization,
      props: true
    },
    {
      path: "/projects/:project_id/incidents",
      name: "incidents",
      component: Incidents,
      props: true
    },
    {
      path: "/projects/:project_id/groups",
      name: "groups",
      component: Groups,
      props: true
    },
    {
      path: "/projects/:project_id/groups/new",
      name: "NewGroup",
      component: Group,
      props: true
    },
    {
      path: "/projects/:project_id/groups/:id",
      name: "group",
      component: Group,
      props: true
    },
    {
      path: "/projects/:project_id/meter-units/:id/record/manage",
      name: "manage-record",
      component: ManageRecord,
      props: true
    },
    {
      path: "/organizations",
      name: "organizations",
      component: Organizations
    },
    {
      path: "/organizations/:id",
      name: "organization",
      component: Organization
    },

    {
      path: "/system",
      name: "system",
      component: System
    },
    {
      path: "/addressbooks/:id",
      name: "Addressbook",
      component: Addressbook,
      props: true
    },
    {
      path: "/contacts/new",
      name: "NewContact",
      component: Contact
    },
    {
      path: "/contacts/:id",
      name: "Contact",
      component: Contact,
      props: true
    },
    {
      path: "/documents/:id",
      name: "Document",
      component: Document,
      props: true
    },
    {
      path: "/folder/:id",
      name: "Folder",
      component: Folder,
      props: true
    },

    {
      path: "/projects/:project_id/cost-centres",
      name: "cost-centres",
      component: CostCentres,
      props: true
    },
    {
      path: "/projects/:project_id/cost-centres/:id",
      name: "cost-centre",
      component: CostCentre,
      props: true
    },
    {
      path: "/projects/:project_id/contract-periods",
      name: "contract-periods",
      component: ContractPeriods,
      props: true
    },
    {
      path: "/projects/:project_id/cost-allocator/new",
      name: "new-cost-allocator",
      component: CostAllocator,
      props: true
    },
    {
      path: "/projects/:project_id/cost-allocator/:id",
      name: "cost-allocator",
      component: CostAllocator,
      props: true
    },
    {
      path: "/projects/:project_id/billing-periods",
      name: "billing-periods",
      component: BillingPeriods,
      props: true
    },
    {
      path: "/projects/:project_id/billing-periods/new",
      name: "new-billing-period",
      component: BillingPeriod,
      props: true
    },
    {
      path: "/projects/:project_id/billing-periods/:id",
      name: "billing-period",
      component: BillingPeriod,
      props: true
    },
    {
      path: "/projects/:project_id/cost-items",
      name: "cost-items",
      component: CostItems,
      props: true
    },
    {
      path: "/projects/:project_id/cost-items/:id",
      name: "cost-item",
      component: CostItem,
      props: true
    },
    {
      path: "/projects/:project_id/consumption-accounting",
      name: "consumption-accounting",
      component: ConsumptionAccounting
    },

    {
      path: "/projects/:project_id/export/upload",
      name: "accounting-export",
      component: DataExportUpload
    },
    {
      path: "/projects/:project_id/export/validate/:id",
      name: "accounting-export-validation",
      component: DataExportValidation
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});
router.beforeEach((to, from, next) => {
  store.dispatch("notificationStore/hideAllNotifications");
  if (!(to.meta && to.meta.notForHistory)) {
    store.dispatch("historyStore/setRouterBefore", from);
  }
  if (!window.localStorage.userToken && to.path !== "/login") {
    window.localStorage.urlBeforeLogin = window.location.href;
    next("/login");
  } else next();
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};
export default router;
